import autoClearTimer from '@/mixins/auto-clear-timer';

const MAX_DEGREE = 45;

const doll = {
  mixins: [autoClearTimer],
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
    showBubbles: {
      type: Boolean,
      default: true,
    },
    showClenchHint: {
      type: Boolean,
      default: false,
    },
    clenchHintDuration: {
      type: Number,
      default: 3,
    },
    bubbleActions: {
      type: Array,
      default: () => [],
    },
    left: {
      type: Number,
      default: 0,
    },
    right: {
      type: Number,
      default: 0,
    },
    leftRange: Array,
    rightRange: Array,
    showProgress: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: -1,
    },
    leftBreathing: Boolean,
    rightBreathing: Boolean,
    scanOngoing: Boolean,
  },
  methods: {
    onClenchEnded() {
      this.$emit('update:showClenchHint', false);
    },
  },
  computed: {
    armRotationBase() {
      return 10;
    },
    leftArmStyles() {
      const [min, max] = this.leftRange;
      const delta = max - min;
      let value = 0;
      if (this.left <= min) {
        value = 0;
      } else if (this.left >= max) {
        value = MAX_DEGREE;
      } else {
        value = (this.left - min) * (MAX_DEGREE / delta);
      }
      return {
        transform: `rotateZ(${-this.armRotationBase + value}deg)`,
      };
    },
    rightArmStyles() {
      const [min, max] = this.rightRange;
      const delta = max - min;
      let value = 0;
      if (this.right <= min) {
        value = 0;
      } else if (this.right >= max) {
        value = MAX_DEGREE;
      } else {
        value = (this.right - min) * (MAX_DEGREE / delta);
      }
      return {
        transform: `rotateZ(${this.armRotationBase - value}deg)`,
      };
    },
    canHitBoth() {
      return this.showBubbles && this.bubbleActions.length === 0;
    },
    isLeftHit() {
      const [min, max] = this.leftRange;
      const isHit = this.left >= min && this.left <= max;
      // hitting right has higher priority
      if (!this.showBubbles || (isHit && this.isRightHit && !this.canHitBoth)) return false;

      return isHit;
    },
    isRightHit() {
      const [min, max] = this.rightRange;
      const isHit = this.right >= min && this.right <= max;
      return this.showBubbles && isHit;
    },
    areBothHit() {
      return this.isLeftHit && this.isRightHit;
    },
  },
  watch: {
    isLeftHit(nv) {
      this.$emit('left-hit', nv);
    },
    isRightHit(nv) {
      this.$emit('right-hit', nv);
    },
    showClenchHint: {
      handler(nv, ov) {
        if (nv && !ov && !this.useClenchAnimation) {
          this.setAutoClearTimer(this.onClenchEnded, this.clenchHintDuration * 1000);
        }
      },
      immediate: true,
    },
  },
};

export default doll;
